import { connect } from "react-redux";
import PosReturn from "./posReturn";
import { bindActionCreators } from "redux";
import {
  getPosShipmentAndReasons,
  replaceOrReturnPos
} from "services/redux/installation/tagDelivery/action";

const mapStateToProps = (state) => ({
  posRequirement: state.tagDeliveryReducer.posReasonAndMaterials,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPosShipmentAndReasons,
      replaceOrReturnPos
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PosReturn);
